<adapt-dialog [maxWidth]="900">
    <h3 adapt-dialog-title>{{ title }}</h3>

    <div adapt-dialog-content>
        @if (!!connection) {
            <adapt-edit-role-connections [connection]="connection"
                                         (roleConnectionDeletion)="onDeletion($event)"></adapt-edit-role-connections>
        }
        @if (culturalLeadershipConfiguration) {
            <div role="alert"
                 class="alert alert-info mt-3">
                <span>{{ culturalLeadershipConfiguration.primaryName }} roles can only be updated in Cultural Leadership Framework.</span>
            </div>
        }
    </div>

    <adapt-standard-dialog-buttons adapt-dialog-footer
                                   [discardConfirmationInstance]="instance"></adapt-standard-dialog-buttons>
</adapt-dialog>
